import moment from 'moment';
import { Customer, CustomerCreditApplication, CustomerDetails, CustomerStatus } from '@trnsact/trnsact-shared-types';
import { CreditAppTableRow, CustomerTableRow } from '../types';
import { Typography } from '@mui/material';
import { DateFormats } from 'constants/common';
import { formatCurrency } from 'utils';
import { CustomerStatusChip } from '../ui/components';
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ViewListIcon from '@mui/icons-material/ViewList';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

export const formatCustomersToTableData = (customers: Customer[]): CustomerTableRow[] => {
  return customers.map(customer => ({
    id: customer.accountId,
    accountId: customer.accountId,
    name: customer.name ?? '',
    contactName: customer.contactName ?? '',
    phone: customer.phone ?? '',
    type: customer.type ?? '',
    lastContactDate: customer.lastContactDate ?? '',
    status: customer.status ?? CustomerStatus.Active,
    totalRevenueAmount: customer.totalRevenueAmount,
    activeDealsNumber: customer.activeDealsNumber,
    opportunitiesNumber: customer.opportunitiesNumber,
  }));
};

export const formatCreditAppsToTableData = (creditAppData: CustomerCreditApplication[]): CreditAppTableRow[] => {
  return creditAppData.map(ca => ({
    id: ca.creditApplicationId,
    vendorOpportunityId: ca.vendorOpportunity?.vendorOpportunityId ?? '',
    createdDateTime: ca.createdDateTime ?? '-',
    applyingFor: ca.applyingFor?.join(', ') ?? '-',
    signedBy:
      ca.owners
        ?.filter(o => o!.signatureDate)
        .map(o => [o!.firstName, o!.lastName].filter(Boolean).join(' '))
        .join(', ') ?? '-',
    salesRep: ca.vendorOpportunity?.salesRepresentative?.fullName ?? '-',
    location: ca.location?.locationName ? `${ca.location.locationName}, ${ca.location.category}` : '-',
    equipment: ca.vendorOpportunity?.equipmentDescription ?? '-',
  }));
};

export const getCustomerInfoCardsConfiguration = (customerDetails: CustomerDetails) => [
  {
    title: 'Customer Status',
    icon: <PersonIcon color="primary" />,
    content: <CustomerStatusChip status={customerDetails.status} />,
  },
  {
    title: 'First Contact',
    icon: <CalendarTodayIcon color="primary" />,
    content: (
      <Typography variant="h6" component="p">
        {moment(customerDetails.firstContactDate).format(DateFormats.Short)}
      </Typography>
    ),
  },
  {
    title: 'Last Contact',
    icon: <CalendarTodayIcon color="primary" />,
    content: (
      <Typography variant="h6" component="p">
        {customerDetails.lastContactDate ? moment(customerDetails.lastContactDate).format(DateFormats.Short) : '-'}
      </Typography>
    ),
  },
  {
    title: 'Last Sale',
    icon: <DoneAllIcon color="primary" />,
    content: (
      <Typography variant="h6" component="p">
        {customerDetails.lastSaleDate ? moment(customerDetails.lastSaleDate).format(DateFormats.Short) : '-'}
      </Typography>
    ),
  },
  {
    title: 'Open Opportunities',
    icon: <ViewListIcon color="primary" />,
    content: (
      <Typography variant="h6" component="p">
        {customerDetails.activeOpportunitiesNumber}
      </Typography>
    ),
  },
  {
    title: 'Total Revenue',
    icon: <AttachMoneyIcon color="primary" />,
    content: (
      <Typography variant="h6" component="p">
        {customerDetails.totalRevenueAmount ? formatCurrency(customerDetails.totalRevenueAmount) : '-'}
      </Typography>
    ),
  },
];
